<template>
  <div>
    <base-page-heading title="Quote Templates">
      <template #extra>
        <b-button
          v-if="$can('create', 'QuoteTemplate')"
          variant="primary"
          v-b-tooltip.hover
          title="Create a new Quote Template"
          @click="() => $router.push({ name: 'new-quote-template' })"
        >
          <i class="fa fa-plus" />
          <span class="ml-1 d-none d-md-inline">New Template</span>
        </b-button>
      </template>
    </base-page-heading>
    <div class="content">
      <b-row>
        <b-col>
          <quote-templates-list-filter
            :columns="columns"
            :initial-filters="filters"
            @filters-applied="applyFilters"
          />
        </b-col>
      </b-row>
      <quote-templates-table
        :filters="filters"
        :columns="columns"
        :current-page="pagination.currentPage"
        :per-page="pagination.perPage"
        :key="tableKey"
      />
    </div>
  </div>
</template>

<script>
import QuoteTemplatesTable from '@/components/admin/quoteTemplates/Table.vue';
import QuoteTemplatesListFilter from '@/components/admin/quoteTemplates/ListFilter.vue';
import listMixin from '@/mixins/listMixin';
import { QUOTE_TEMPLATE_TABLE_NAME } from '@/constants/quoteTemplates';

export default {
  name: 'QuoteTemplatesList',
  components: {
    QuoteTemplatesTable,
    QuoteTemplatesListFilter,
  },
  mixins: [listMixin],
  props: {
    text: String,
    active: String,
    client_id: String,
    service_id: String,
  },
  data() {
    return {
      tableName: QUOTE_TEMPLATE_TABLE_NAME,
      filters: {
        text: this.text,
        active: this.active,
        client_id: this.client_id,
        service_id: this.service_id,
      },
      tableKey: Date.now(),
    };
  },
  methods: {
    refreshTable() {
      this.tableKey = Date.now();
    },
  },
};
</script>
